import { useEffect, useState } from "react";
import axios from "axios";
import Select from "react-select";
import { toast } from "react-toastify";
import { getAuth } from "firebase/auth";

export default function BoardMembersEditor({ board_role }) {
  const [members, setMembers] = useState(board_role.members || []);
  const [allUsers, setAllUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const auth = getAuth();
        const user = auth.currentUser;
        
        if (!user) {
          toast.error("Authentication required");
          return;
        }

        const token = await user.getIdToken();
        const headers = { Authorization: `Bearer ${token}` };
        
        const res = await axios.get("/api/directory", { headers });
        setAllUsers(res.data);
      } catch (error) {
        console.error("Failed to fetch users:", error);
        toast.error("Failed to fetch users");
      }
    };

    fetchUsers();
  }, []);

  const handleChange = (index, field, value) => {
    const updated = [...members];
    updated[index][field] = value;
    setMembers(updated);
  };

  const handleAddMember = () => {
    setMembers([...members, { userId: "", role: "" }]);
  };

  const handleRemoveMember = (index) => {
    const updated = [...members];
    updated.splice(index, 1);
    setMembers(updated);
  };

  const saveMembers = async () => {
    try {
      const auth = getAuth();
      const user = auth.currentUser;
      
      if (!user) {
        toast.error("Authentication required");
        return;
      }

      const token = await user.getIdToken();
      const headers = { Authorization: `Bearer ${token}` };
      
      await axios.patch(`/api/board/${board_role._id}/members`, members, { headers });
      toast.success("Roles updated!");
    } catch (error) {
      console.error("Error saving members:", error);
      toast.error("Something went wrong");
    }
  };

  return (
  <div className="border p-3 mt-2 bg-light rounded">
    <p className="mb-2"><strong>Members</strong></p>

    {members.map((member, index) => (
      <div key={index} className="d-flex mb-2 gap-2 align-items-center" style={{ flexWrap: "nowrap" }}>
        <div style={{ flex: "2 1 0%", minWidth: 0 }}>
          <Select
            className="basic-single"
            options={allUsers.map(user => ({
              value: user._id,
              label: `${user.surname}, ${user.first_name}${user.known_as ? ` (${user.known_as})` : ""}`
            }))}
            value={allUsers
              .map(user => ({
                value: user._id,
                label: `${user.surname}, ${user.first_name}${user.known_as ? ` (${user.known_as})` : ""}`
              }))
              .find(option => option.value === member.userId)}
            onChange={(selectedOption) =>
              handleChange(index, "userId", selectedOption ? selectedOption.value : "")
            }
            isClearable
            placeholder="Select member"
            styles={{ container: (base) => ({ ...base, width: "100%" }) }}
          />
        </div>

        <button className="btn btn-outline-secondary btn-sm" onClick={() => handleRemoveMember(index)}>×</button>
      </div>
    ))}

    <div className="d-flex gap-2 mt-2">
      <button className="btn btn-custom-outline btn-sm" onClick={handleAddMember}>
        + Add Member
      </button>
      <button className="btn btn-admin btn-sm" onClick={saveMembers}>
        Save Members
      </button>
    </div>
  </div>
);

}
